import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import { useLocation } from 'reservations/account/providers/ConfigProvider';
import { formatPhone } from 'reservations/base/helpers/phone';
import BookingConfirmationDetailCard from 'reservations/confirmation/components/BookingConfirmationDetailCard';
import { ShareLocationButton } from 'reservations/preDining/components/ShareLocationButton';

const LocationModule = () => {
  const {
    state,
    street,
    city,
    postal_code,
    phone_number,
    email_address,
    name
  } = useLocation();

  const redirectToLocation = () => {
    const address = `${name}, ${street}, ${city}, ${state} ${postal_code}`;
    const encodedAddress = encodeURIComponent(address);
    const directionLink = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;

    window.open(directionLink, '_blank');
  };

  const contactInfo = phone_number
    ? formatPhone(`${phone_number}`)
    : email_address;
  return (
    <BookingConfirmationDetailCard
      header="Location"
      endAdornment={<ShareLocationButton />}
    >
      <Box sx={{ display: 'grid', gap: '1.125rem' }}>
        <Box>
          <Typography sx={{ fontSize: '18px' }}>{street}</Typography>
          <Typography sx={{ fontSize: '18px' }}>
            {`${city}, ${state} ${postal_code}`}
          </Typography>
        </Box>
        {contactInfo && (
          <Typography sx={{ fontSize: '18px' }}>{contactInfo}</Typography>
        )}
      </Box>
      <Button onClick={redirectToLocation}>Get Directions</Button>
    </BookingConfirmationDetailCard>
  );
};

export default LocationModule;
